module.exports = __webpack_public_path__ + "static/img/14TA700S.f09ac12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/sport/04sportDesc/14TA700S.png
// module id = eyHa
// module chunks = 0